<template>
<div>
  <!-- <el-multi-switch
    :options="[
      { value: 'all', label: 'All' },
      { value: 'success', label: 'Success' },
      { value: 'info', label: 'Info' }
    ]"
    v-model="filter"
    />
  <br> -->
  <transition-group name="list-add">
    <el-inline margin-top
      v-for="item in filteredLatest"
      :key="item.id"
      :space-between="true"
      :wrap="false"
      class="animation"
      >
      <div>
      <b>{{item.message}}</b><br>
      <span style="color: #777; font-size: 14px;">{{getTime(new Date(item.timestamp))}}</span>
      </div>

      <el-tag
        :success="item.status === 'success'"
        :info="item.status === 'info'"
        >
        {{item.status}}
      </el-tag>
    </el-inline>
  </transition-group>
</div>
</template>
<script>

import dataLog from 'services/dataLog.js'

export default {
  computed: {
    filteredLatest () {
      if (this.filter === 'all') {
        return this.latest
      }

      return this.latest.filter(item => item.status === this.filter)
    },
    latest () {
      return this.$store.getters.latest
    }
  },
  data () {
    return {
      filter: 'all'
    }
  },
  mounted () {
    dataLog.getLatest()
  },
  methods: {
    getTime (d) {
      return ('00' + (d.getMonth() + 1)).slice(-2) + '/' +
        ('00' + d.getDate()).slice(-2) + '/' +
        d.getFullYear() + ' ' +
        ('00' + d.getHours()).slice(-2) + ':' +
        ('00' + d.getMinutes()).slice(-2) + ':' +
        ('00' + d.getSeconds()).slice(-2)
    }
  }
}
</script>
<style lang="less" scoped>
  .list-add-item {
    transition: all 1s;
  }
  .list-add-enter {
    opacity: 0;
    transform: translateY(30px);
  }
</style>
